import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MultiSelectModule } from 'primeng/multiselect';
import { ErrormessageModule } from '../../validation/errormessage/errormessage.module';

import { PCPCommunityMultiSelectComponent } from "./pcp-community-multi-select.component";

@NgModule({
    imports: [
        CommonModule,
        ErrormessageModule,
        FormsModule,
        MultiSelectModule,        
        PCPCommunityMultiSelectComponent,
    ],
    exports: [PCPCommunityMultiSelectComponent]
})
export class PCPCommunityMultiSelectModule { }
